import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/login.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent {
  constructor(private authService: AuthService) {}

  signOut(): void {
    this.authService.signOut();
  }
}
